// eslint-disable-next-line jira/export/no-external-exports
export { usePrevious } from '@atlassian/jira-platform-react-hooks-use-previous';
